export default {
  created() {
    this.$root.sharedEventBus.$on(`designer:highlight:${this.getSectionNamespace()}:apply`, () => this.highlightSection())
    this.$root.sharedEventBus.$on(`designer:highlight:${this.getSectionNamespace()}:remove`, () => this.removeSectionHighlight())
  },

  methods: {
    getSectionNamespace() {
      return ''
    },

    highlightSection() {
      this.sectionHighlighted = true
    },

    removeSectionHighlight() {
      this.sectionHighlighted = false
    },
  },

  computed: {
    sectionHighlightClasses() {
      if (!this.sectionHighlighted) {
        return ''
      }

      return ' designer-section-highlighted'
    },
  },

  data() {
    return {
      sectionHighlighted: false,
    }
  },
}
